<div class="select-wallet-container">
	<!--Fiat Wallets-->
	<tc-empty-template
		*ngIf="(fiatWalletList && fiatWalletList.length<1) && (cryptoWalletList && cryptoWalletList.length<1) && !isLoading">
	</tc-empty-template>
	<ng-container *ngIf="fiatWalletList && fiatWalletList.length>0 && !isLoading">

		<span class="wallet-type-title">{{'WALLET.FIAT_WALLETS' | translate}}</span>

		<tc-inline-alert *ngIf="wallets && !wallets.fiat.enable" [type]="inlineAlertTypes.info"
			[text]="wallets.fiat.stateMessage"></tc-inline-alert>
		<div class="wallet-container" #wallets (resized)="onResized($event)"
			*ngIf="fiatWalletList && !(fiatWalletList && fiatWalletList.length<1 && !isLoading)">



			<div *ngFor="let item of fiatWalletList" [class]="'wallet selectable ' + walletClass"
				[ngClass]="{'selected': selectedWallet && item.accountNumber === selectedWallet.accountNumber, 'lock': item.transactionState!==walletTransactionStates.Usable}"
				(click)="selectWallet(item)">
				<div class="wallet-content">
					<div class="icon-check-circle"></div>
					<div class="detail">
						<div class="wallet-icon">
							<i class="icon-wallet-vt"></i>
						</div>
						<div class="info">
							<div class="type">{{item.walletName}}</div>
							<div class="number">{{item.accountNumber}}</div>
						</div>
					</div>
					<div class="amount">
						<div class="number">{{item.balance | tcCurrency: item.precision}} </div>
						<div class="currency">{{item.currencyCode}}</div>
					</div>
				</div>
				<div class="lock-wallet">
					<div class="fas fa-lock" *ngIf="item.transactionState!==walletTransactionStates.Usable"></div>
					<div class="lock-description">
						<div class="top">
							<i class="icon-cancel"></i>
							<!-- <i class="fas fa-lock" *ngIf="item.transactionState!==walletTransactionStates.Usable"></i>  -->
							<!-- <div class="diactive-label" *ngIf="item.transactionState===walletTransactionStates.CurrencyDisabled">
								<span class="txt">{{'WALLET.DIACTIVE' | translate}}</span>
							</div> -->
						</div>
						<div class="text">
							<ng-container *ngIf="item.transactionState===walletTransactionStates.Locked">
								{{'WALLET.LOCK_MESSAGE' | translate}}</ng-container>

							<ng-container *ngIf="item.transactionState===walletTransactionStates.CurrencyDisabled">
								{{'WALLET.CURRENCY_IS_DEACTIVE' | translate}}</ng-container>
						</div>
					</div>
				</div>
			</div>
		</div>
	</ng-container>
	<ng-container *ngIf="showCrypto">
		<ng-container *ngIf="cryptoWalletList && cryptoWalletList.length>0 && !isLoading">
			<!--Crypto Wallets-->
			<span class="wallet-type-title">{{'WALLET.CRYPTO_WALLETS' | translate}}</span>

			<tc-inline-alert *ngIf="wallets && !wallets.crypto.enable" [type]="inlineAlertTypes.info"
				[text]="wallets.crypto.stateMessage"></tc-inline-alert>

			<div class="wallet-container"
				*ngIf="cryptoWalletList && !(cryptoWalletList && cryptoWalletList.length<1 && !isLoading)"
				(resized)="onResized($event)">
				<div *ngFor="let item of cryptoWalletList" [class]="'wallet selectable ' + walletClass"
					[ngClass]="{'selected': selectedWallet && item.accountNumber === selectedWallet.accountNumber, 'lock': item.transactionState!==walletTransactionStates.Usable, 'deactive': !wallets.crypto.enable}"
					(click)="selectWallet(item)">
					<div class="wallet-content">
						<div class="icon-check-circle"></div>
						<div class="detail">
							<div class="wallet-icon">
								<i class="icon-wallet-vt"></i>
							</div>
							<div class="info">
								<div class="type">{{item.walletName}}</div>
								<div class="number">{{item.accountNumber}}</div>
							</div>
						</div>
						<div class="amount">
							<div class="number">{{item.balance | tcCurrency: item.precision}} </div>
							<div class="currency">{{item.currencyCode}}</div>
						</div>
					</div>

					<div class="lock-wallet">
						<div class="fas fa-lock" *ngIf="item.transactionState===walletTransactionStates.Locked"></div>
						<div class="lock-description">
							<div class="top">
								<i class="icon-cancel"></i>
								<i class="fas fa-lock"
									*ngIf="item.transactionState===walletTransactionStates.Locked"></i>
								<div class="diactive-label"
									*ngIf="item.transactionState===walletTransactionStates.CurrencyDisabled">
									<span class="txt">{{'WALLET.DIACTIVE' | translate}}</span>
								</div>
							</div>
							<div class="select-wallet-container">
								<!--Fiat Wallets-->
								<tc-empty-template
									*ngIf="(fiatWalletList && fiatWalletList.length<1) && (cryptoWalletList && cryptoWalletList.length<1) && !isLoading">
								</tc-empty-template>
								<ng-container *ngIf="fiatWalletList && fiatWalletList.length>0 && !isLoading">

									<span class="wallet-type-title">{{'WALLET.FIAT_WALLETS' | translate}}</span>

									<tc-inline-alert *ngIf="wallets && !wallets.fiat.enable"
										[type]="inlineAlertTypes.info"
										[text]="wallets.fiat.stateMessage"></tc-inline-alert>
									<div class="wallet-container" #wallets (resized)="onResized($event)"
										*ngIf="fiatWalletList && !(fiatWalletList && fiatWalletList.length<1 && !isLoading)">



										<div *ngFor="let item of fiatWalletList"
											[class]="'wallet selectable ' + walletClass"
											[ngClass]="{'selected': selectedWallet && item.accountNumber === selectedWallet.accountNumber}"
											(click)="selectWallet(item)">
											<div class="wallet-content">
												<div class="icon-check-circle"></div>
												<div class="detail">
													<div class="wallet-icon">
														<i class="icon-wallet-vt"></i>
													</div>
													<div class="info">
														<div class="type">{{item.walletName}}</div>
														<div class="number">{{item.accountNumber}}</div>
													</div>
												</div>
												<div class="amount">
													<div class="number">{{item.balance | tcCurrency: item.precision}}
													</div>
													<div class="currency">{{item.currencyCode}}</div>
												</div>
											</div>
										</div>
									</div>
								</ng-container>

								<ng-container *ngIf="cryptoWalletList && cryptoWalletList.length>0 && !isLoading">
									<!--Crypto Wallets-->
									<span class="wallet-type-title">{{'WALLET.CRYPTO_WALLETS' | translate}}</span>

									<tc-inline-alert *ngIf="wallets && !wallets.crypto.enable"
										[type]="inlineAlertTypes.info"
										[text]="wallets.crypto.stateMessage"></tc-inline-alert>

									<div class="wallet-container"
										*ngIf="cryptoWalletList && !(cryptoWalletList && cryptoWalletList.length<1 && !isLoading)"
										(resized)="onResized($event)">
										<div *ngFor="let item of cryptoWalletList"
											[class]="'wallet selectable ' + walletClass"
											[ngClass]="{'selected': selectedWallet && item.accountNumber === selectedWallet.accountNumber, 'deactive': !wallets.crypto.enable}"
											(click)="selectWallet(item)">
											<div class="wallet-content">
												<div class="icon-check-circle"></div>
												<div class="detail">
													<div class="wallet-icon">
														<i class="icon-wallet-vt"></i>
													</div>
													<div class="info">
														<div class="type">{{item.walletName}}</div>
														<div class="number">{{item.accountNumber}}</div>
													</div>
												</div>
												<div class="amount">
													<div class="number">{{item.balance | tcCurrency: item.precision}}
													</div>
													<div class="currency">{{item.currencyCode}}</div>
												</div>
											</div>
										</div>

									</div>
								</ng-container>

								<tc-table-loading *ngIf="isLoading"></tc-table-loading>
							</div>

							<div class="text">
								<ng-container *ngIf="item.transactionState===walletTransactionStates.Locked">
									{{'WALLET.LOCK_MESSAGE' | translate}}</ng-container>

								<ng-container *ngIf="item.transactionState===walletTransactionStates.CurrencyDisabled">
									{{'WALLET.CURRENCY_IS_DEACTIVE' | translate}}</ng-container>
							</div>
						</div>
					</div>
				</div>

			</div>
		</ng-container>
	</ng-container>

	<tc-table-loading *ngIf="isLoading"></tc-table-loading>
</div>